import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["flag", "preview"]

  remove(event) {
    event.preventDefault()
    this.flagTarget.value = "1"
    this.previewTarget.hidden = true
  }
}
